import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Button } from '../../../components/ui/button';
import { Gift, Save } from 'lucide-react';

export function ReferralSettings({ data, setData, isSaving, onSave }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">Referral Program</h3>
          <p className="text-sm text-slate-500 mt-1">
            Configure the refer-a-friend rewards program
          </p>
        </div>
        <div className={`px-3 py-1.5 rounded-full text-sm font-medium ${
          data.enabled 
            ? 'bg-green-100 text-green-700' 
            : 'bg-stone-100 text-stone-500'
        }`}>
          {data.enabled ? 'Program Active' : 'Program Inactive'}
        </div>
      </div>

      {/* Enable/Disable Toggle */}
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl mb-6">
        <div>
          <p className="font-medium text-slate-900">Enable Referral Program</p>
          <p className="text-sm text-slate-500">
            Allow users to earn rewards by referring new customers
          </p>
        </div>
        <Switch
          checked={data.enabled}
          onCheckedChange={(checked) => setData(prev => ({ ...prev, enabled: checked }))}
          data-testid="referral-toggle"
        />
      </div>

      <div className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>Reward Amount (Php)</Label>
            <Input
              type="number"
              placeholder="100"
              value={data.reward_amount}
              onChange={(e) => setData(prev => ({ ...prev, reward_amount: Number(e.target.value) }))}
              className="h-12 mt-1.5"
              data-testid="referral-reward"
            />
            <p className="text-xs text-slate-500 mt-1">
              Reward given to both referrer and referee
            </p>
          </div>
          <div>
            <Label>Required Bookings</Label>
            <Input
              type="number"
              placeholder="5"
              value={data.required_bookings}
              onChange={(e) => setData(prev => ({ ...prev, required_bookings: Number(e.target.value) }))}
              className="h-12 mt-1.5"
              data-testid="referral-bookings"
            />
            <p className="text-xs text-slate-500 mt-1">
              Bookings the referee must complete to unlock reward
            </p>
          </div>
        </div>

        <div>
          <Label>Program Description</Label>
          <textarea
            placeholder="Describe the referral program..."
            value={data.description}
            onChange={(e) => setData(prev => ({ ...prev, description: e.target.value }))}
            className="w-full h-24 px-4 py-3 mt-1.5 border border-stone-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-amber-500"
            data-testid="referral-description"
          />
        </div>

        <div className="p-4 bg-amber-50 rounded-xl">
          <div className="flex items-start gap-3">
            <Gift className="w-5 h-5 text-amber-600 mt-0.5" />
            <div>
              <p className="font-medium text-amber-900">How It Works</p>
              <ul className="text-sm text-amber-700 mt-2 space-y-1">
                <li>1. Users share their unique referral code</li>
                <li>2. New users sign up using the referral code</li>
                <li>3. Referee completes {data.required_bookings} paid bookings</li>
                <li>4. Both parties receive Php {data.reward_amount} in their wallets</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Button 
        onClick={onSave}
        disabled={isSaving}
        className="mt-6 bg-slate-900 hover:bg-slate-800"
        data-testid="save-referral-btn"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? 'Saving...' : 'Save Referral Settings'}
      </Button>
    </div>
  );
}
